import React, {useContext} from 'react'
import { Modal, Descriptions, Card, Tooltip, Tag} from 'antd';
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import { IsStormvloed } from '@utils';
import { appContext } from '../../../AppContext';

export default function SkillWikiModal({isModalVisible, setIsModalVisible, record, allSkills, allRaces}){

    const [appState] = useContext(appContext);
    const isStormvloed = IsStormvloed(appState.storyName)

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    function getRequiredSkills() {
        
        
        const requiredSkills = []
        const requiredAndSkills = []
        const mutualExclusiveSkills = []

        if(record.requiredSkills?.length > 0) {
            record.requiredSkills.forEach(_ => {
                const found = allSkills.find(skill => skill.id === _.requiredSkillId || 
                                                skill.skill?.id === _.requiredSkillId);
    
                if(found !== undefined) {
                    requiredSkills.push(found.skill === undefined ? found : found.skill)
                }
            })
        }

        if(record.andRequiredSkills?.length > 0) {
            record.andRequiredSkills.forEach(_ => {
                const found = allSkills.find(skill => skill.id === _.requiredSkillId || 
                                                skill.skill?.id === _.requiredSkillId);
    
                if(found !== undefined) {
                    requiredAndSkills.push(found.skill === undefined ? found : found.skill)
                }
            })
        }

        if(record.mutualExclusiveSkills?.length > 0) {

            
            record.mutualExclusiveSkills.forEach(_ => {
                const found = allSkills.find(skill => skill.id === _.id || 
                                                skill.skill?.id === _.id);
    
                if(found !== undefined) {
                    mutualExclusiveSkills.push(found.skill === undefined ? found : found.skill)
                }
            })
        }

        if(requiredSkills.length <= 0 && requiredAndSkills.length <= 0 && mutualExclusiveSkills.length <= 0){
            return null
        }

        const requiredSkillsTags = requiredSkills.map(_ => 
            <Tooltip key={_} title="(Skill requirement) At least one of the purple tag is required to get this skill">
              <Tag color="purple">{_.name}</Tag>
            </Tooltip>
          )
        const requiredAndSkillsTags = requiredAndSkills.map(_ => 
        <Tooltip key={_} title="(Skill requirement) All of the orange tags are required to get this skill">
            <Tag color="orange">{_.name}</Tag>
        </Tooltip>
        )
        const requiredMutualTags = mutualExclusiveSkills.map(_ => 
            <Tooltip key={_} title="(Skill requirement) All of the yellow tags are skills that you can't have in combination with this skill">
              <Tag color="yellow">(not) {_.name}</Tag>
            </Tooltip>
          )

        return (
            <Descriptions.Item label="Required skills">{requiredSkillsTags}{requiredAndSkillsTags}{requiredMutualTags}</Descriptions.Item>
            )
    }

    function getRequiredRaces() {
        if(record.requiredRaces?.length <= 0 || record.requiredRaces === undefined) {
            return null;
        }
        
        const requiredRaces = [];
        record.requiredRaces.forEach(_ => {
            const found = allRaces.find(race => race.id === _.raceId);
            if(found !== undefined) {
                requiredRaces.push(found)
            }

        })

        const requiredRacesTags = requiredRaces.map(_ => 
            <Tooltip key={_} title={`(${isStormvloed ? "Race" : "World"} requirement) At least one of the blue tags is required to get this skill`}>
              <Tag color="blue">{_.name}</Tag>
            </Tooltip>
          )

        return (<Descriptions.Item label={isStormvloed ? "Races" : "Worlds"} > {requiredRacesTags} </Descriptions.Item>)
    }

    function getRequiredStat() {
        if(record.requiredStats?.length <= 0 || record.requiredStats === undefined) {
            return null;
        }
        
        const requiredStats = record.requiredStats;
        const requiredStatTags = requiredStats.map(_ => 
            <Tooltip key={_} title="(Stat requirement) All of the red tags are required to get this skill">
              <Tag color="red">{_.statType.name} {_.amount}</Tag>
            </Tooltip>
          )

        return (<Descriptions.Item label="Required Stats">{requiredStatTags}</Descriptions.Item>)
    }

    function getIncreaseStat() {
        if(record.increaseStats?.length <= 0 || record.increaseStats === undefined) {
            return null;
        }
        
        const increaseStats = record.increaseStats;
        const requiredStatTags = increaseStats.map(_ => 
              <Tag key={_} color="green">+ {_.amount} {_.statType.name}</Tag>
          )

        return (
            <Descriptions.Item label="Stats that will be increased">{requiredStatTags}</Descriptions.Item>
            )
    }


    return (
            <Modal 
                title={`Selected skill : ${record.name}`}  
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
            >
                <Descriptions bordered>
                    <Descriptions.Item label="Name">{record.name}</Descriptions.Item>
                    <Descriptions.Item label="Skill point cost">{record.pointCost}</Descriptions.Item> 
                    {isStormvloed && <Descriptions.Item label="Skill point type">{record.skillPointType?.name}</Descriptions.Item>}
                    {getRequiredSkills()}
                    {getRequiredRaces()}
                    {getRequiredStat()}
                    {getIncreaseStat()}
                </Descriptions>

                <br />
                <Card title="Description">
                    <TextEditorReadOnly 
                        content={record.description}
                    />
                </Card>
            </Modal>
    )
}